import "../../styles/styles.css";

import { Card, Col, Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import SelectorIdioma from "../../components/SelectorIdioma/SelectorIdioma";
import ciclosService from "../../services/ciclos";
import { useTranslation } from "react-i18next";
import portugale700 from "./../../assets/portugale700.jpg";
import escudo from "./../../assets/Logo_Ayto_sinfondo.png";

function Home() {
  const [t, i18n] = useTranslation("global");
  const [loading, setloading] = useState(true);
  const [ciclos, setCiclos] = useState([]);

  useEffect(() => {
    async function getCiclos() {
      let ciclo = await ciclosService.getCiclos();

      setCiclos(ciclo);
      if (loading) {
        setloading(false);
      }
    }
    getCiclos();
  }, [loading]);
  return (
    <Container fluid className="home">
      {loading === true ? (
        <div></div>
      ) : (
        <div>
          <Row style={{ height: "100px" }}>
            <Col
              xs={7}
              md={1}
              style={{
                justifyContent: "center",
                display: "flex",
                marginRight: "30px",
              }}
            >
              <SelectorIdioma />
            </Col>
            <Col
              md={10}
              xs={12}
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <Col md={8} xs={12}></Col>
              <Col>
                <img style={{ width: "280px" }} src={escudo} alt="banner"/>
              </Col>
              <Col style={{ padding: "0", marginLeft:"10px", marginRight:"-22px" }}>
                <img style={{ width: "130px" }} src={portugale700} alt="banner"/>
              </Col>      
            </Col>
          </Row>

          <Row style={{ justifyContent: "center", display: "flex" }}>
            <div className="bannerHome" alt=""></div>
          </Row>
          <Row
            style={{
              width: "70%",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "15px",
              justifyContent: "center",
            }}
          >
            <div className="selectorHome">
              <div className="selecciona-el-cicloHome">{t("header.title")}</div>
            </div>
          </Row>
          {loading ? (
            <div></div>
          ) : (
            <Row style={{ marginTop: "60px", marginBottom: "100px" }}>
              {ciclos.map((data, key) => {
                return (
                  <Col
                    key={key}
                    style={{
                      margin: "30px",
                      justifyContent: "center",
                      display: "flex",
                    }}
                    sm={true}
                    md={true}
                  >
                    <Link to={"ciclo/" + data.tags[1]}>
                      <Card
                        style={{
                          borderRadius: "10px",
                          boxShadow: "6px 6px 18px #00000029",
                          minWidth: "300px",
                          maxWidth: "300px",
                        }}
                      >
                        <Card.Img variant="top" src={data.banner} />
                        <Card.Body>
                          <Card.Title>
                            {i18n.language === "es" ? (
                              <div>{data.name}</div>
                            ) : (
                              <div>
                                {data.name === "Biblioteca Municipal" ? (
                                  <div>Udal Liburutegia</div>
                                ) : (
                                  <div>
                                    {data.name ===
                                    "Museo de la Industria Rialia" ? (
                                      <div>Rialia Industria Museoa</div>
                                    ) : (
                                      <div>
                                        {data.name === "Espectáculos" ? (
                                          <div>Ikuskizuna</div>
                                        ) : (
                                          <div>
                                            {data.name ===
                                            "Centro Cultural Santa Clara" ? (
                                              <div>Santa Clara Kulturtegia</div>
                                            ) : (
                                              <div></div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Card.Title>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          )}
        </div>
      )}
    </Container>
  );
}

export default Home;
